// extracted by mini-css-extract-plugin
module.exports = {"adverts":"AdvertList_adverts__2NNJs","advertsEmpty":"AdvertList_advertsEmpty__3wiK8","advertsGrid":"AdvertList_advertsGrid__2uTbN"};